import { createFileRoute } from "@tanstack/react-router";
import { validateQuoteSearch } from "@/lib/quote-search";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/es/cotizacion")({
  validateSearch: validateQuoteSearch,
  head: () => buildHead({
    locale: "es",
    title: "Solicitar Alcance Shopify · Shugert",
    description: "Comparte la restricción Shopify, confirma el proyecto de entrada más cercano y recibe un siguiente paso enfocado de Shugert.",
    path: "/es/cotizacion",
    altPath: alternatePath("/es/cotizacion", "en"),
    noindex: true,
    jsonLd: breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Solicitar alcance", path: "/es/cotizacion" }]),
  }),
});